<template>
  <div class="home mt-2">
    <h2>Perfil</h2>
    <hr />

    <div v-if="user" class="card mb-4">
      <div class="card-body">
        <div class="form-group row mb-2">
          <label class="col-sm-2 col-form-label font-weight-bold">Usuario:</label>
          <div class="col-sm-10 d-flex align-items-center">
            <span>{{ user.name || "-" }}</span>
          </div>
        </div>

        <div class="form-group row mb-2">
          <label class="col-sm-2 col-form-label font-weight-bold">Email:</label>
          <div class="col-sm-10 d-flex align-items-center">
            <span>{{ user.email || "-" }}</span>
          </div>
        </div>

        <div class="form-group row mb-2">
          <label class="col-sm-2 col-form-label font-weight-bold">Rol:</label>
          <div class="col-sm-10 d-flex align-items-center">
            <span>{{ user.rol === "admin" ? "Administrador" : (user.rol === "integrador" ? "Integrador" : user.rol) }}</span>
          </div>
        </div>

        <div class="form-group row mb-2">
          <label class="col-sm-2 col-form-label font-weight-bold">Integrador:</label>
          <div class="col-sm-10 d-flex align-items-center">
            <span v-if="userdata && userdata.integrador">{{ userdata.integrador }}</span>
            <span v-else-if="integradores && integradores.data && integradores.data.length">{{ integradores.data[0].integrador }}</span>
            <span v-else-if="user.id_integrador">ID: {{ user.id_integrador }}</span>
            <span v-else>-</span>
          </div>
        </div>
      </div>
    </div>

    <h2 class="mt-4">Credenciales</h2>
    <hr />

    <div
      v-if="userdata && userdata.apisecret"
      class="alert alert-success d-flex align-items-center"
      role="alert"
    >
      <div class="w-100 text-center py-2">
        <p class="mb-2">
          <b>Api Token: </b> <code>{{ userdata.apitoken }}</code>
        </p>
        <p class="mb-0">
          <b>Api Secret: </b>
          <code v-if="!userdata.showSecret">{{ userdata.apisecret }}</code>
          <code v-else>***************************************</code>
          <button
            type="button"
            class="btn btn-outline-secondary btn-sm ml-2"
            @click="userdata.showSecret = !userdata.showSecret"
            :title="userdata.showSecret ? 'Mostrar Secret' : 'Ocultar Secret'"
          >
            <i :class="userdata.showSecret ? 'bi bi-eye-slash-fill' : 'bi bi-eye-fill'"></i>
          </button>
        </p>
      </div>
    </div>

    <div
      v-else-if="userdata && !userdata.apisecret"
      class="alert alert-info text-center py-3"
      role="alert"
    >
      Solicite su Api Token y Api Secret para utilizar las APIs disponibles.
    </div>

    <div v-if="docsUrl" class="mt-4 text-center">
      <hr />
      <p class="text-muted">
        Visite el
        <a :href="docsUrl" target="_blank" rel="noopener noreferrer" class="font-weight-bold">
          centro de documentación
        </a>
        para más información sobre el uso de nuestras APIs.
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "Perfil",

  data() {
    return {
      userdata: {
        apitoken: null,
        apisecret: null,
        integrador: null,
        showSecret: true,
        showApiToken: false,
      },
      errors: [],
      isLoadingUser: false,
    };
  },

  computed: {
    ...mapGetters("auth", ["user"]),
    ...mapGetters("integrador", ["integradores"]),
    docsUrl() {
      const envUrl = process.env.VUE_APP_DOCS_URL;
      if (envUrl !== undefined) {
        const trimmed = String(envUrl).trim();
        if (trimmed === "" || trimmed.toLowerCase() === "false" || trimmed.toLowerCase() === "none") {
          return null;
        }
        return trimmed;
      }
      return "https://docs.smsconsulting.company";
    },
  },

  watch: {
    user: {
      immediate: true,
      handler(newUser) {
        if (newUser && newUser.name) {
          this.loadUserCredentials(newUser);
        }
      },
    },
  },

  mounted() {
    if (this.user && this.user.name) {
      this.loadUserCredentials(this.user);
    }
  },

  methods: {
    loadUserCredentials(currentUser) {
      if (!currentUser || !currentUser.name || this.isLoadingUser) {
        return;
      }
      if (currentUser.apitoken || currentUser.apisecret || currentUser.api_token) {
        this.userdata = {
          ...this.userdata,
          apitoken: currentUser.apitoken || currentUser.api_token,
          apisecret: currentUser.apisecret,
          integrador: currentUser.integrador,
          showSecret: true,
          showApiToken: false,
        };
      }
      this.isLoadingUser = true;
      this.$store.commit("setLoading", true);

      axios
        .post(process.env.VUE_APP_API_URL + "usuario/busqueda", {
          name: currentUser.name,
          page: 1,
        })
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.data &&
            response.data.data.length > 0
          ) {
            const u = response.data.data[0];
            this.userdata = {
              ...u,
              showSecret: true,
              showApiToken: false,
            };
          }
        })
        .catch((e) => {
          this.errors.push(e);
        })
        .finally(() => {
          this.isLoadingUser = false;
          this.$store.commit("setLoading", false);
        });
    },
  },
};
</script>

<style scoped>
code {
  font-size: 1rem;
  color: #1b4b72;
}
</style>
